import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  body {
    height: 100%;
    margin: 0px;
    padding: 0px;
  }
`

export default GlobalStyles
